export default class CarClassWriteDTO {

    public id: number | undefined;
    public name: string | undefined;
    public label: string | undefined;

    constructor(data: { [key: string]: any }) {
        this.id = data['id'] || undefined;
        this.name = data['name'] || undefined;
        this.label = data['label'] || undefined;
    }
}
